import { IQuestion, IAnswerItem } from "../types";
import { IAnswer } from '../apps/exam/types'

export function getGroupQuestion(questions): IQuestion<IAnswerItem>[][] {
  let groups = questions.reduce((group: {question_index: number, questions: IQuestion<IAnswerItem>[]}, question) => {
    if (!group[question.group]){
      group[question.group] = { question_index: null, questions: [] }
    }
    group[question.group].questions.push(question)
    return group
  }, {})

  let question_index = 0
  for (let group_index in groups) {
    let groupQuestion = groups[group_index]
    let questions = groupQuestion.questions
    for (let index in questions) {
      if(questions[index].fieldType){
        question_index += 1
        groupQuestion["question_index"] = question_index
        break
      }
    }
  }
  return Object.keys(groups).map((groupId) => groups[groupId])
}

export function checkAnsweredGroup(questions: IQuestion<IAnswerItem>[], answers: IAnswer[]): boolean{
  for (let i = 0; i < questions.length; i++) {
    let question = questions[i]
    let answer = answers.find((answer) => answer.q_id == question.id)
    if(!answer || !answer.body){
      return false
    }
  }
  return true
}

export function checkBlankGroupQuestion(questions: IQuestion<IAnswerItem>[]): boolean {
  for (let index in questions) {
    if(questions[index].fieldType){
      return false
    }
  }
  return true
}